import { AddToFavorite } from "@/ui/Common/AddToFavorite";
import { cn } from "@/utils/cn";
import { Share } from "@/widgets/Share";

interface ObjectDetailHeaderProps {
  title: string | null;
  objectId?: string;
  className?: string;
}

export function ObjectDetailHeader({
  title,
  objectId,
  className,
}: ObjectDetailHeaderProps) {
  return (
    <div className={cn("flex w-full gap-[1rem] items-start", className)}>
      <h1 className="flex-1 text-[2.5rem] md:text-[3rem] text-dark font-bold">
        {title}
      </h1>

      <div className="flex gap-8 md:justify-end mt-2 md:mt-[11px]">
        <Share title={title ?? ""} />
        {objectId && (
          <AddToFavorite
            className={"text-[#323232]"}
            id={objectId}
          />
        )}
      </div>
    </div>
  );
}
